import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import EventForm from './pages/EventForm';
import DisplayForm from './pages/DisplayForm';
import UpdateForm from './pages/UpdateForm';
import UpdateQuestionsForm from './pages/UpdateQuestionsForm';
import { useAuth } from './context/AuthContext';

function AppContent() {
  const location = useLocation();
  const { verifyToken } = useAuth();
  const hasVerified = useRef(false);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  console.log('AppContent rendered, token:', token);

  useEffect(() => {
    if (token && !hasVerified.current) {
      console.log('useEffect ran, token:', token);
      hasVerified.current = true;
      verifyToken(token);
    } else if (!token) {
      console.error('No token provided in URL');
      // window.location.href = 'https://platform-a.com?error=no_token';
    }
  }, [token, verifyToken]);

  return (
    <div className="app-container">
      <Routes>
        <Route path="/eventform" element={<EventForm />} />
        <Route path="/display" element={<DisplayForm />} />
        <Route path="/" element={<DisplayForm />} />
        <Route path="/update/:id" element={<UpdateForm />} />
        <Route path="/update-questions/:exerciseId" element={<UpdateQuestionsForm />} />
      </Routes>
    </div>
  );
}

function App() {
  console.log('App rendered');
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;